@if (visible) {
<div class="card card--relative">
    <div class="card-block">
        <div class="row">
            <div class="col text-center">
                <p class="textBody--sm m-0">
                    <i class="fa fa-info-circle mr-1 text-info"></i>{{message}}
                </p>
            </div>
        </div>
    </div>
</div>
}